import { render, staticRenderFns } from "./LmInitiatorTypesNewOrEdit.vue?vue&type=template&id=36546302"
import script from "./LmInitiatorTypesNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmInitiatorTypesNewOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports